import { FC, ReactNode } from 'react';
import { Button, ButtonPropsType, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { AdvertContactDataItemType } from '@edikk-edikk/country-frontend';
import { AdvertSocialLinkIcon } from '#components/social-link';
import { useBaseContext } from '#base/hooks';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  socialLink: AdvertContactDataItemType;
  variant?: ButtonPropsType['variant'];
  size?: ButtonPropsType['size'];
  circle?: ButtonPropsType['circle'];
  buttonAdditionalClassName?: string;
};

const AdvertSocialLink: FC<PropsType> = ({
  socialLink,
  variant = ButtonVariant.unstyled,
  size = null,
  circle = false,
  buttonAdditionalClassName = null,
}) => {
  const { isBot } = useBaseContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();

  const wrapLink = (node: ReactNode): ReactNode => {
    if (!isBot && isDeleted) {
      return node;
    }

    if (!socialLink.url) {
      return node;
    }

    return (
      <Button
        variant={variant}
        circle={circle}
        size={size}
        linkSimpleProps={{
          href: socialLink.url,
          target: '_blank',
        }}
        additionalClassName={buttonAdditionalClassName}
      >
        {node}
      </Button>
    );
  };

  return wrapLink(<AdvertSocialLinkIcon alias={socialLink.alias} />);
};

export { AdvertSocialLink };
